import { render, staticRenderFns } from "./FicheRecette.vue?vue&type=template&id=26c75c5a"
import script from "./FicheRecette.vue?vue&type=script&lang=js"
export * from "./FicheRecette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports